/**
 * Created by Tiger on 01/03/2022.
 */

import i18n from 'i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import {initReactI18next} from 'react-i18next';
import enResource from '../locale/en_US';
import zhResource from '../locale/zh_CN';

i18n.use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    ns: '', resources: {
      en: { translation: enResource }, zh: { translation: zhResource },
    }, fallbackLng: 'en', debug: true, interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
  }).then(r => console.log('i18n init success', r))
  .catch(e => console.err('i18n init failed:', e));

export default i18n;